export const Count = (count)=>[
        'count',
        count
    ];
export const increment = ([type, value])=>[
        type,
        value + 1
    ];
export const AccountId = (id)=>[
        'account_id',
        id
    ];
export const UserId = (id)=>[
        'user_id',
        id
    ];
export const CompanyId = (id)=>[
        'company_id',
        id
    ];
export const PermissionId = (id)=>[
        'permission_id',
        id
    ];
export const ProjectId = (id)=>[
        'project_id',
        id
    ];
export const ProjectPhaseId = (id)=>[
        'project_phase_id',
        id
    ];
export const ProjectConversationId = (id)=>[
        'project_conversation_id',
        id
    ];
export const TemplateId = (id)=>[
        'template_id',
        id
    ];
export const InvoiceId = (id)=>[
        'invoice_id',
        id
    ];
export const TaskId = (projectId, taskId)=>[
        'task_id',
        projectId,
        taskId
    ];
export const TaskIdV2 = (taskId)=>[
        'task_id',
        taskId
    ];
export const DocumentId = (documentId)=>[
        'document_id',
        documentId
    ];
export const SpaceId = (projectId, spaceId)=>[
        'space_id',
        projectId,
        spaceId
    ];
export const SpaceTabId = (projectId, spaceId, spaceTabId)=>[
        'space_tab_id',
        projectId,
        spaceId,
        spaceTabId
    ];
export const StatusUpdateId = (statusUpdateId)=>[
        'status_update_id',
        statusUpdateId
    ];
export const ApprovalId = ([, projectId, taskId], approvalId)=>[
        'approval_id',
        projectId,
        taskId,
        approvalId
    ];
export const FormInstanceId = (projectId, instanceId)=>[
        'form_instance_id',
        projectId,
        instanceId
    ];
export * from './core-types';
